import { Component, OnInit } from '@angular/core';
import { AuthService } from '../login/auth.service';
import { SharedService } from '../shared_service';

import { NavigationStart, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd, NavigationCancel } from '@angular/router';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { ThisSoftwareUpdateService } from '../services/angular_software_update.service'
import { AuthInactivityService } from '../services/auth-inactivity.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
	auth: AuthService;
  loading = true;
  permissions = [];
  public showContent = false;
  public title;

	constructor(
		auth: AuthService,
		private _sharedService: SharedService,
		private _router: Router,
		
		private permissionsService: NgxPermissionsService,
		private _auth: AuthService,
		private _softwareUpdateService: ThisSoftwareUpdateService,
		private _authInactivityService: AuthInactivityService
	) {
		this.auth = auth;
		_sharedService.changeEmitted$.subscribe(
			returnUrl => {
				if (returnUrl === 'home') {
					this._router.navigate(['/intro']);
				}
			}
		)
		_softwareUpdateService.initApplicationUpdating();
	}
	ngOnInit() {

    // page progress bar percentage
    this._router.events.subscribe(event => {
		if (event instanceof NavigationStart) {
		  // set page progress bar loading to start on NavigationStart event router
		  
		}
		if (event instanceof RouteConfigLoadStart) {
		  
		}
		if (event instanceof RouteConfigLoadEnd) {
		  
		}
		if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
		  // set page progress bar loading to end on NavigationEnd event router
		  
		  this.showContent = true;
		}
	  });

	  // Iniciar timer de inactividad solo si el usuario está autenticado
	  if (this._authInactivityService.isLoggedIn()) {
	    this._authInactivityService.restartInactivityTimer();
	  }
	}

	ngOnDestroy() {
	  // El timer se detiene automáticamente a través del servicio intermedio
	}
}
